import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import ShareMedia from 'srcReact/components/common2/ShareMedia'
import DeleteMediaConfirmation from '../../../../MessengerPage/components/DeleteMediaConfirmation'
import { useTranslation } from 'react-i18next'
import Modal from '../../Modal'
import Carousel, { consts } from 'react-elastic-carousel'
import FileContent from '../FileContent'
import { downloadMedia, isFileImage, openMedia } from 'srcReact/helpers/fileHelper'
import { validatePDFMIMEType, getDescryptedMedia, getNativeDecryptedMedia } from 'srcReact/helpers/utils'
import Spinner from '../../Spinner'
import IconButton from '../../IconButton'
import Icon from 'srcReact/components/icons/Icon'

function FileNavigation({
  isMobileDevice,
  file,
  fileIndex,
  files,
  showShareButton,
  loggedInUserId,
  enableDeleteFile,
  openedConversation,
  loadingFileDeletion,
  showPagination,
  isDecrypted,
  plain,
  deleteFile,
  closeModal,
  isNative,
  fullScreen,
  setFullScreen,
  feed,
  scrollToFeeds
}) {
  const { t } = useTranslation()
  const fileContainer = useRef()
  const carouselRef = useRef()

  const [currentFile, setCurrentFile] = useState(file)
  const [currentFileIndex, setCurrentFileIndex] = useState(fileIndex)
  const [allFiles, setAllFiles] = useState(files)

  const [showShareModal, setShowShareModal] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showDeleteButton, setShowDeleteButton] = useState(false)
  const [deleteTrigged, setDeleteTrigged] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    if (fileContainer) {
      fileContainer.current.focus()
    }
  }, [])

  useEffect(() => {
    if (!loadingFileDeletion && deleteTrigged) {
      setDeleteTrigged(false)
      closeDeleteModal()
      const updatedFiles = allFiles.filter((f) => f.id !== currentFile.id)
      if (updatedFiles.length === 0) {
        closeModal()
      } else {
        if (currentFileIndex >= updatedFiles.length) {
          setCurrentFile(updatedFiles[updatedFiles.length - 1])
        } else {
          setCurrentFile(updatedFiles[currentFileIndex])
        }
        setAllFiles(updatedFiles)
      }
    }
  }, [loadingFileDeletion, deleteTrigged])

  useEffect(() => {
    const isOwner = loggedInUserId === currentFile.user_id
    if (isOwner && enableDeleteFile) {
      if (currentFile.is_from_newsfeed === 1) {
        setShowDeleteButton(false)
      } else {
        setShowDeleteButton(true)
      }
    }
  }, [currentFile])

  // useEffect(() => {
  //   setCurrentFile(file)
  //   setCurrentFileIndex(fileIndex)
  //   setAllFiles(files)
  // }, [feed])

  const downloadFile = (file) => {
    setShowSpinner(true)
    if (file?.url) {
      const { url, is_original, original_tag, mime_type } = file
      const isOriginal = is_original == 0 ? 0 : 1
      getDescryptedMedia(url, isOriginal, original_tag, mime_type, file.id ?? file.id_file ?? file.file_id).then(
        (data) => {
          setShowSpinner(false)
          // native decryption
          if (isNative) {
            getNativeDecryptedMedia(url, data.img, isOriginal, original_tag, mime_type, file.name)
            return
          }
          downloadMedia(isOriginal, data.img, file.name || file.original_file_name)
        }
      )
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      carouselRef.current.slideNext()
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      carouselRef.current.slidePrev()
    }
  }

  const onCurrentChange = (current) => {
    const { item, index } = current
    setCurrentFile(item.file)
    setCurrentFileIndex(index)
  }

  const openShareModal = () => {
    setShowShareModal(true)
  }

  const closeShareModal = () => {
    setShowShareModal(false)
  }

  const openDeleteModal = () => {
    setShowDeleteModal(true)
  }

  const closeDeleteModal = () => {
    setShowDeleteModal(false)
  }

  const openFile = (file) => {
    if (validatePDFMIMEType(file)) {
      const { url, is_original, original_tag, mime_type } = file
      getDescryptedMedia(url, is_original, original_tag, mime_type, file.id).then((data) => {
        // native decryption
        if (isNative) {
          getNativeDecryptedMedia(url, data.img, is_original, original_tag, mime_type, file.name, 'open')
          return
        }
        openMedia(is_original, data.img, file.name)
      })
    }
  }

  const handleDeleteFile = () => {
    // setDeleteTrigged(true)
    // if (messageId) {
    //   deleteFile(messageId, currentFile.id.toString())
    // } else {
    //   deleteFile(currentFile.id)
    // }
  }

  const goPrev = () => {
    carouselRef.current.slidePrev()
  }
  const goNext = () => {
    carouselRef.current.slideNext()
  }

  const myArrow = ({ type, onClick, isEdge }) => {
    return type === consts.PREV ? (
      <IconButton
        iconSize='large32'
        iconName={'chevron-left24'}
        className={`${styles.btnWithIcon} ${styles.btnArrow} ${styles.leftArrow}`}
        iconCSS={styles.actionIcon}
        onClick={onClick}
        disabled={isEdge}
      />
    ) : (
      <IconButton
        iconSize='large32'
        iconName={'chevron-right24'}
        className={`${styles.btnWithIcon} ${styles.btnArrow}  ${styles.rightArrow}`}
        iconCSS={styles.actionIcon}
        onClick={onClick}
        disabled={isEdge}
      />
    )
  }
  const handleZoomIn = () => {
    const currentWidth = imageRef.current.clientWidth
  }
  const handleZoomout = () => {}

  return (
    <React.Fragment>
      <div
        ref={fileContainer}
        onKeyDown={(e) => {
          handleKeyDown(e)
        }}
        className={`${styles.fileContainer} ${fullScreen ? styles.fullScreen : styles.nonFullScreen} ${
          !isFileImage(currentFile) && styles.docFileContainer
        }`}
        tabIndex={-1}>
        <div className={styles.imageHeader}>
          <div className={styles.leftActions}>
            <IconButton
              iconName='close24'
              iconSize='large24'
              className={`${styles.btnWithIcon} ${styles.btnClose}`}
              onClick={closeModal}
            />
          </div>
          {allFiles?.length > 0 && (
            <div className={styles.centerActions}>
              {allFiles && allFiles.length > 1 && (
                <IconButton iconName='chevron-left24' iconSize='large24' iconCSS={styles.actionIcon} onClick={goPrev} />
              )}
              <div className={styles.stats}>{`${currentFileIndex + 1}/${allFiles.length}`}</div>
              {allFiles && allFiles.length > 1 && (
                <IconButton
                  iconName='chevron-right24'
                  iconSize='large24'
                  iconCSS={styles.actionIcon}
                  onClick={goNext}
                />
              )}
            </div>
          )}
          <div className={styles.rightActions}>
            {false && isFileImage(currentFile) && (
              <div className={styles.zoomButtons}>
                <IconButton
                  iconName='zoom-in'
                  iconSize='large24'
                  className={styles.btnWithIcon}
                  iconCSS={styles.actionIcon}
                  onClick={handleZoomIn}
                />
                <IconButton
                  iconName='zoom-out'
                  iconSize='large24'
                  className={styles.btnWithIcon}
                  iconCSS={styles.actionIcon}
                  onClick={handleZoomout}
                />
              </div>
            )}

            {validatePDFMIMEType(currentFile) && currentFile?.is_original === 1 && (
              <IconButton
                className={styles.btnWithIcon}
                id='native_image_download'
                iconCSS={styles.actionIcon}
                iconName='pdf'
                iconSize='large24'
                {...(!showSpinner ? { onClick: () => openFile(currentFile) } : {})}
              />
            )}
            <IconButton
              className={styles.btnWithIcon}
              id='native_image_download'
              iconName='download24'
              iconSize='large24'
              iconCSS={styles.actionIcon}
              onClick={() => downloadFile(currentFile)}
            />

            {showShareButton && (
              <IconButton
                className={styles.btnWithIcon}
                iconName='share'
                iconSize='large24'
                iconCSS={styles.actionIcon}
                onClick={openShareModal}
              />
            )}

            {showDeleteButton && (
              <IconButton
                className={styles.btnWithIcon}
                iconName='delete'
                iconSize='large24'
                iconCSS={styles.actionIcon}
                onClick={openDeleteModal}
              />
            )}

            {!isMobileDevice && feed && (
              <IconButton
                className={styles.btnWithIcon}
                iconName={fullScreen ? 'collapse' : 'expand'}
                iconSize='large24'
                iconCSS={styles.actionIcon}
                onClick={() => setFullScreen(!fullScreen)}
              />
            )}
          </div>
        </div>
        {plain ? (
          <div>
            <FileContent file={currentFile} isDecrypted={isDecrypted} isImage={true} />
          </div>
        ) : (
          <div
            className={`${styles.imageBody} ${
              isMobileDevice && allFiles.length > 15 ? styles.small : allFiles.length > 10 ? styles.medium : ''
            }`}>
            <Carousel
              ref={carouselRef}
              initialActiveIndex={fileIndex}
              onNextEnd={onCurrentChange}
              onPrevEnd={onCurrentChange}
              breakPoints={[{ itemsToShow: 1 }, { itemsToScroll: 1 }]}
              pagination={showPagination && isMobileDevice && allFiles.length > 1 ? true : false}
              renderArrow={myArrow}
              showArrows={isMobileDevice || allFiles.length <= 1 ? false : true}>
              {allFiles.map((f, index) => {
                return <FileContent file={f} isDecrypted={isDecrypted} isImage={isFileImage(currentFile)} />
              })}
            </Carousel>
          </div>
        )}
        {isMobileDevice && feed && (
          <div className={styles.imageFooter}>
            <div className={styles.rightActions}>
              <button
                onClick={scrollToFeeds}
                type='button'
                className={`${styles.commentsButton} ${feed?.responses?.length > 0 && styles.commentGreenButton}`}>
                {feed?.responses?.length > 0 && <span>{feed.responses?.length}</span>}
                <Icon name='discussion' size='large24' />
              </button>
            </div>
          </div>
        )}
      </div>

      {showSpinner && (
        <div className={styles.loaderContainer}>
          <Spinner customCss={styles.loader} />
          <span>{t('global.downloadLoading')}</span>
        </div>
      )}

      {showShareModal && (
        <Modal
          nested
          isOpen={showShareModal}
          handleClose={closeShareModal}
          closeOnDocumentClick={true}
          title={t('messenger.shareMedia.shareMediaTitle')}>
          <ShareMedia mediaFile={currentFile} closeModal={closeShareModal} openedConversation={openedConversation} />
        </Modal>
      )}
      {showDeleteModal && (
        <Popup
          contentStyle={{ width: '27rem', marginTop: '6rem' }}
          nested
          open={showDeleteModal}
          onClose={closeDeleteModal}>
          <DeleteMediaConfirmation
            mediaFile={currentFile}
            closeModal={closeDeleteModal}
            deleteMedia={handleDeleteFile}
            loadingFileDeletion
            deleteTrigged={deleteTrigged}
            fileType={isFileImage(currentFile) ? 'image' : 'document'}
          />
        </Popup>
      )}
    </React.Fragment>
  )
}

export default FileNavigation
